<template>
  <div
    class="project-structure-plan-point"
    :style="`
      left: calc(${coordinates.x * model_zoom}px);
      top: calc(${coordinates.y * model_zoom}px);
      ${!text?'border: 1px solid black;':''}
      `"
    >
    <div v-if="!text" class="project-structure-plan-point-vertical"/>
    <div v-if="!text" class="project-structure-plan-point-horizontal"/>
    <div v-if="text" class="project-structure-plan-point-text">
      <input
        v-if="input"
        class="project-structure-plan-point-input"
        :value="text"
        type="number"
        @change="$emit('changeValue', $event.target.value)"
        >
        <div v-else class="mr-1">
          {{text}}
        </div>
        <div>{{unit?unit:'m'}}</div>
        <sup style="line-height: 24px" v-if="dimension">{{dimension}}</sup>
    </div>
    <div
      v-if="name"
      class="project-structure-plan-point-name"
      >
      {{name}}
    </div>
  </div>
</template>
<script>
  export default {
    props: ['input', 'coordinates', 'model_zoom', 'text', 'name', 'unit', 'dimension'],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-plan-point {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 30px;
    border-radius: 30px;
    z-index: 30;
    transform: translate(-50%, -50%);

    /* background-color: white; */
  }
  .project-structure-plan-point:focus {
    outline: none;
  }
  .project-structure-plan-point-vertical {
    position: absolute;
    height: 29px;
    width: 1px;
    left: 14px;
    background-color: black;
  }
  .project-structure-plan-point-horizontal {
    position: absolute;
    height: 1px;
    width: 29px;
    top: 14px;
    background-color: black;
  }
  .project-structure-plan-point-text {
    display: flex;
    background-color: white;
    color: black;
    border: 1px black solid;
    width: 100px !important;
    border-radius: 4px;
    padding: 0px 1px 0px 1px;
    user-select: none;
  }
  .project-structure-plan-point-input {
    text-align: right;
    user-select: none;
    width: 70px !important;
  }
  .project-structure-plan-point-name {
    margin-top: 53px;
    color: black;
    font-size: 12px;
    background-color: white;
    border: solid black 1px;
    border-radius: 4px;
    padding: 0px 1px 0px 1px;
    user-select: none;
  }
</style>
